import React, { useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { XR, createXRStore, useXR } from '@react-three/xr';
import { Environment, OrbitControls } from '@react-three/drei';

// Create XR store
const store = createXRStore();

// VR Button component using direct store method
function VRButton() {
  return (
    <button 
      onClick={() => store.enterVR()}
      style={{
        position: 'absolute',
        bottom: '24px',
        right: '24px',
        background: '#00b3ff',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '12px 24px',
        fontWeight: 'bold',
        zIndex: 999,
        cursor: 'pointer'
      }}
    >
      Enter VR
    </button>
  );
}

// Interactive object component
function InteractiveObject({ position }) {
  const [color, setColor] = useState('blue');
  
  return (
    <mesh 
      position={position} 
      onClick={() => setColor(color === 'blue' ? 'red' : 'blue')}
    >
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color={color} />
    </mesh>
  );
}

// Main VR scene component
function VRScene() {
  const { isPresenting } = useXR();
  
  return (
    <>
      <ambientLight intensity={0.5} />
      <directionalLight position={[10, 10, 5]} intensity={1} />
      
      {/* Interactive objects */}
      <InteractiveObject position={[0, 1.5, -5]} />
      
      <mesh position={[-2, 1, -3]}>
        <sphereGeometry args={[0.7, 32, 32]} />
        <meshStandardMaterial color="red" />
      </mesh>
      
      {/* Floor */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]}>
        <planeGeometry args={[20, 20]} />
        <meshStandardMaterial color="green" />
      </mesh>
      
      {/* Only use OrbitControls when not in VR */}
      {!isPresenting && <OrbitControls />}
    </>
  );
}

// Main component
function VRWorld() {
  const [isLoading, setIsLoading] = useState(true);
  
  React.useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, []);
  
  if (isLoading) {
    return <div>Loading VR World...</div>;
  }
  
  return (
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      <VRButton />
      <Canvas camera={{ position: [0, 1.7, 5] }}>
        <XR store={store}>
          <Environment preset="sunset" />
          <VRScene />
        </XR>
      </Canvas>
    </div>
  );
}

export default VRWorld; 